import { render, staticRenderFns } from "./LogNewCallModal.vue?vue&type=template&id=79cf0bc0"
import script from "./LogNewCallModal.vue?vue&type=script&lang=js"
export * from "./LogNewCallModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports